import React from 'react'
import { RECOMMENDED } from "../constants";


const Badge = ({title, classes}) => {
    return (
        <span className={`badge ${classes}`}>{title || RECOMMENDED}</span>
    )
}

export default Badge




// WEBPACK FOOTER //
// ./resources/assets/js/modules/Badge.js